import { useState, useEffect } from "react";
import { fetchStop } from "../services/fetchData.js";
import { startStatus, endStatus } from "../services/statusStore.js";

export default function useStopDetails(stopId) {
  const [stop, setStop] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(Boolean(stopId));

  useEffect(() => {
    if (!stopId) {
      setStop(null);
      setError(false);
      setLoading(false);
      return;
    }

    let active = true;
    let errorStatusId = null;

    const statusId = startStatus("Loading stop details...");

    setStop(null);
    setError(false);
    setLoading(true);
    fetchStop(stopId)
      .then((data) => {
        if (!active) return;
        setStop(data?.[stopId] || data);
        setLoading(false);
        endStatus(statusId);
      })
      .catch(() => {
        if (!active) return;

        setStop(null);
        setError(true);
        setLoading(false);
        endStatus(statusId);
        errorStatusId = startStatus("Failed to load stop data.");
        setTimeout(() => {
          if (errorStatusId !== null) {
            endStatus(errorStatusId);
          }
        }, 4000);
      });

    return () => {
      active = false;
      endStatus(statusId);

      if (errorStatusId !== null) {
        endStatus(errorStatusId);
      }
    };
  }, [stopId]);

  return { stop, error, loading };
}
